import { type PseudoStateDataMap, type RuntimePseudoState } from '../../types';
import { checkPseudoState, getStateData, hasStateData, pseudoStatesPriority } from '../pseudo-state-shared';

/**
 * Resolves the currently active pseudo state and returns its data.
 *
 * @since ??
 *
 * @param {object} params Parameters.
 * @param {HTMLElement} params.hoverElement Element used as pseudo-state trigger root.
 * @param {PseudoStateDataMap<any>} params.stateDataMap State data map.
 *
 * @returns {{state: RuntimePseudoState, stateData: any}} Active state and data.
 */
export const resolvePseudoStateData = <TStateData>({
  hoverElement,
  stateDataMap,
}: {
  hoverElement: HTMLElement;
  stateDataMap: PseudoStateDataMap<TStateData>;
}): {
  state: RuntimePseudoState;
  stateData: TStateData;
} => {
  const resolvedState = pseudoStatesPriority.find(
    state =>
      hasStateData(stateDataMap, state) &&
      checkPseudoState(hoverElement, state) &&
      null !== getStateData(stateDataMap, state),
  );

  if (resolvedState) {
    const stateData = getStateData(stateDataMap, resolvedState);

    if (null !== stateData) {
      return {
        state: resolvedState,
        stateData,
      };
    }
  }

  return {
    state: 'default',
    stateData: stateDataMap.defaultStateData,
  };
};
